import { TableColumn, TableRow } from '@rio-cloud/rio-uikit/Table';

import { DriverName } from '#components/shared/DriverName.tsx';
import type { Driver } from '#domain/model/Driver.ts';
import type { Tour } from '#domain/model/Tour.ts';
import { Location } from '#features/tours/table/Location.tsx';
import { TourProgressBar } from '#features/tours/table/TourProgressBar.tsx';
import TourState from '#features/tours/table/TourState.tsx';

type TourTableRowProps = {
    tour: Tour;
    driver?: Driver;
};

export const TourTableRow = ({ tour, driver }: TourTableRowProps) => (
    <TableRow id={tour.id}>
        <TableColumn columnKey='searchName'>
            <span className='max-width-10pct' title={tour.searchName}>
                {tour.searchName}
            </span>
        </TableColumn>
        <TableColumn columnKey='truckLicensePlate'>
            <span className='white-space-nowrap'>{tour.truck.licensePlate}</span>
        </TableColumn>
        <TableColumn columnKey='trailerLicensePlate'>
            <span className='white-space-nowrap'>{tour.trailer.licensePlate}</span>
        </TableColumn>
        <TableColumn columnKey='driverName'>
            <DriverName driver={driver} />
        </TableColumn>
        <TableColumn columnKey='firstStopEndTarget'>
            <Location
                name={tour.firstStop?.name}
                street={tour.firstStop?.location?.street}
                city={tour.firstStop?.location?.city}
                from={tour.firstStop?.startTarget}
                to={tour.firstStop?.endTarget}
                zipCode={tour.firstStop?.location?.zipCode}
                country={tour.firstStop?.location?.country}
            />
        </TableColumn>
        <TableColumn columnKey='lastStopEndTarget'>
            <Location
                name={tour.lastStop?.name}
                street={tour.lastStop?.location?.street}
                city={tour.lastStop?.location?.city}
                from={tour.lastStop?.startTarget}
                to={tour.lastStop?.endTarget}
                zipCode={tour.lastStop?.location?.zipCode}
                country={tour.firstStop?.location?.country}
            />
        </TableColumn>
        <TableColumn columnKey='progressPercentage'>
            <TourProgressBar tour={tour} />
        </TableColumn>
        <TableColumn columnKey='status'>
            <TourState tour={tour} />
        </TableColumn>
    </TableRow>
);
